import { extend } from "vee-validate";
extend("positive", value => {
  if (value >= 0) {
    return true;
  }
  return "Trường {_field_} phải là số lớn hơn 0";
});
extend("odd", value => {
  if (value % 2 !== 0) {
    return true;
  }
  return "Trường {_field_} phải là số chẵn";
});
extend("one_of", (value, values) => {
  if (values.indexOf(value) !== -1) return true;
  return "Trường {_field_} không hợp lệ";
});
extend("min", {
  validate(value, { length }) {
    return value.length >= length;
  },
  params: ["length"],
  message: "Trường {_field_} phải có ít nhất {length} ký tự"
});
extend("required", {
  validate(value) {
    return {
      required: true,
      valid: ["", null, undefined].indexOf(value) === -1
    };
  },
  message: "Trường {_field_} không được để trống",
  computesRequired: true
});

extend("verify_password", {
  validate: value => {
    var strongRegex = new RegExp(
      "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})"
    );
    return strongRegex.test(value);
  },
  message:
    "Mật khẩu phải chứa ít nhất: 1 chữ cái viết hoa, 1 chữ cái viết thường, 1 số và một ký tự đặc biệt (ví dụ : Abc123@)"
});

extend("onlyletter", {
  validate: value => {
    var strongRegex = new RegExp("^[a-zA-Z0-9]*$");
    return strongRegex.test(value);
  },
  message:
    "Trường {_field_} chỉ bao gồm chữ cái và số, không có khoảng trắng và ký tự đặc biệt"
});
extend("email", {
  validate: value => {
    // eslint-disable-next-line no-useless-escape
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    var strongRegex = new RegExp(re);
    return strongRegex.test(value);
  },
  message: "Email không hợp lệ"
});
